import styled from '@emotion/styled';
import { ITheme } from '../../../themer';
import themed from '../../../themer/themed';

export const SelectCurrent = styled.div<{}, ITheme>`
	color: ${themed(({ select }) => select.current.color)};
`;
